module.exports = __webpack_public_path__ + "img/columnas-duo.ed8a6dc2.svg";